import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 32 32" class="createSvgIcon__Svg-sc-1l8xi8d-0 loXvaP"><path d="M30.5 28 16 3 1.5 28h29Z"></path><path d="m16 3 14.5 25-5.2-3L16 9V3Z" fill="url(#paint3_linear)" style="mix-blend-mode:overlay"></path><path opacity=".2" d="m16 3 14.5 25-5.2-3L16 9V3Z" fill="url(#ValActUp2-a)"></path><path d="M30.5 28h-29l5.2-3h18.6l5.2 3Z" fill="url(#ValActUp2-b)" opacity=".5" style="mix-blend-mode:overlay"></path><path d="M16 3 1.5 28l5.2-3L16 9V3Z" fill="url(#ValActUp2-c)" opacity=".5" style="mix-blend-mode:overlay"></path><defs><radialGradient id="ValActUp2-b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 13 -15 0 16 19)"><stop stop-opacity="0"></stop><stop offset="1"></stop></radialGradient><radialGradient id="ValActUp2-c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 13 -15 0 16 19)"><stop stop-color="#fff"></stop><stop offset="1" stop-color="#fff" stop-opacity="0"></stop></radialGradient><linearGradient id="ValActUp2-a" x1="16" y1="19" x2="30" y2="19" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"></stop><stop offset="1" stop-color="#fff" stop-opacity="0"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
